import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = styled.button`
  width: 100%;
  height: 36px;
  border-radius: 2px;
  background-color: ${props => props.theme.PRIMARY};
  border: none;
  margin-top: 60px;
  font-size: 14px;
  font-weight: bold;
  color: ${props => props.theme.WHITE};
  cursor: pointer;
`;

function ActionButton({ id, children, onClick }) {
  return (
    <Button id={id} type="button" onClick={onClick}>
      {children}
    </Button>
  );
}

ActionButton.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ActionButton;
